export const marcinOrlowski = {
    'firstName': 'Marcin',
    'lastName': 'Orłowski',
    'profession': 'Psycholog, Psychoterapeuta psychodynamiczny',
    'avatar': 'marcin-orlowski.webp',
    'slug': 'psychoterapeuta-marcin-orlowski',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychology', 'personality'],
        ['psychology', 'iq'],
        ['psychology', 'cognitive'],
        ['psychology', 'consultation']
    ]
}